import { CONSTANT } from '../../utils/constants';
import { Button } from 'primereact/button';
import { FileText } from 'lucide-react';

function DocumentItem({ document, onUpdate, onDelete }) {
  const handleDelete = (e) => {
    console.log(e);
    e.stopPropagation();
    onDelete();
  };
  return (
    <div
      className="flex flex-row gap-x-3 items-center rounded border-2 bg-white min-w-64 p-2 pr-5 hover:shadow cursor-pointer"
      onClick={onUpdate}>
      <FileText className="h-10 w-10 text-gray-600" />
      <div className="flex flex-col gap-y-1">
        <p className="font-medium text-base text-gray-800">{document.label}</p>
        <p className="font-medium text-xs text-gray-500">
          {CONSTANT.quatrebis.filePageList.find((f) => f.value === document.type).label}
        </p>
      </div>
      <Button
        rounded
        icon="pi pi-trash"
        severity="danger"
        onClick={handleDelete}
        outlined
        size="small"
        className="!h-9 !w-9"
      />
    </div>
  );
}

export default DocumentItem;
